export const PATHS = {
  MAIN_PAGE: "/",
  CATALOG_PAGE: "/catalogs",
  LOGIN_PAGE: "/login",
  TECHOPERATIONS_PAGE: "/tech-operations",
  TECH_WORKS_PAGE: "/tech-works",
  OBSERVATIONS_PAGE: "/observations",
  MAP_PAGE: "/map",
  FIELDS_PAGE: "/fields",
  FIELD_TECH: "tech",
  FIELD_REPORTS: "reports",
  DASHBOARD: "/dashboard",
  ASSET_USAGE_RECORDS: "/asset-usage-records",
  ASSET_STOCKS: "/asset-stocks",
  EDIT_PAGE: "editing",
  EDIT_NEW_PAGE: "new",
  ACCESS_DENIED: "/access-denied",
  REMOTE_FAILURE: "/remote-failure",
  ACCOUNT_NOT_CONNECTED: "/account-not-connected",
  SESSION_EXPIRED: "/session-expired",
  SIGNED_OUT: "/signed-out",
};

export const PUBLIC_INFO_PATHS = [
  PATHS.ACCESS_DENIED,
  PATHS.REMOTE_FAILURE,
  PATHS.ACCOUNT_NOT_CONNECTED,
  PATHS.SESSION_EXPIRED,
  PATHS.SIGNED_OUT,
];

export const LABEL_ROWS_PER_PAGE = "Строк на странице";

export const TECHOPID_NEW_KEYWORD = "new";

export const ISO8601_DATETIME_FORMAT = "yyyy-MM-dd'T'HH:mm:ss";
export const ISO8601_DATETIME_FORMAT_PLUS_GMT = "yyyy-MM-dd'T'HH:mm:ss.SSS+hh:mm";

// TODO: check it
// export const ISO8601_DATETIME_OFFSET_FORMAT = "yyyy-MM-dd'T'HH:mm:ss";
export const ISO8601_DATE_FORMAT = "yyyy-MM-dd";
export const HUMAN_DATE_FORMAT = "dd.MM.yyyy";
export const HUMAN_DATE_TIME_FORMAT = "dd.MM.yyyy HH:mm";
